<div class="my-account__container">
  <div class="my-account__wrapper">
    <div class="m-b-8 my-account__selection" *ngIf="orgUnit$ | async as orgUnit">
      <div class="h6 text-primary m-b-0">
        {{ 'navMenu.account' | cxTranslate }}
        <span
          *ngIf="!orgUnit.defaultAccount"
          class="h7 ff-bold text-secondary change-btn"
          [attr.tabindex]="0"
          (click)="openSoldToModal()"
          (keyup.enter)="openSoldToModal()"
          >{{ 'navMenu.change' | cxTranslate }}</span
        >
      </div>
      <p class="h7 m-b-8">{{ selectedAccount$ | async }}</p>

      <div class="h6 text-primary m-b-0">
        {{ 'navMenu.address' | cxTranslate }}
        <ng-container *ngIf="addressAccounts$ | async as addressAccounts">
          <span
            class="h7 ff-bold text-secondary change-btn"
            [attr.tabindex]="0"
            *ngIf="!orgUnit.defaultShipTo && addressAccounts.length !== 1"
            (keyup.enter)="openShipToModal()"
            (click)="openShipToModal()"
          >
            {{ 'navMenu.change' | cxTranslate }}</span
          >
        </ng-container>
      </div>
      <p class="h7 m-b-8">{{ selectedAddress$ | async }}</p>
    </div>
    <cx-page-slot id="account-nav" position="HeaderLinks"></cx-page-slot>
  </div>
</div>
